import React from 'react'
import HomePage from './pages/HomePage.js'
import './App.css'

const App = () => {
  return <HomePage />
}

export default App
